import * as R from 'ramda';

// This signals in the reducer that we've received new data for this keyWindow.
// entityMap expects a map of entity arrays keyed to the type of entity.
//  e.g. { categories: [...], queries: [...] }
const receiveEntities = (projectionKey, ...nsEntities) => {
  return ({
    type: 'RECEIVE_ENTITIES',
    payload: {
      projectionKey,
      keyWindow: projectionKey,
      entities: nsEntities
        .map(ns => ({
          type: ns.type,
          byId: { ...ns.byId },
          ids: [...ns.ids],
        }))
        .reduce((acc, ns) => ({ ...acc, [ns.type]: ns }), {}),
    },
  });
};

const receiveErrors = (projectionKey, errorMap = {}) => {
  return ({
    type: 'RECEIVE_ERRORS',
    payload: {
      projectionKey,
      keyWindow: projectionKey,
      errors: errorMap,
    },
  });
};


const releaseKeyWindow = (projectionKey) => {
  return ({
    type: 'RELEASE_KEY_WINDOW',
    payload: {
      projectionKey,
      keyWindow: projectionKey,
    },
  });
};

const releaseProjectionKey = (projectionKey) => {
  return ({
    type: 'RELEASE_PROJECTION_KEY',
    payload: {
      projectionKey,
      keyWindow: projectionKey,
    },
  });
};

export default {
  receiveEntities,
  releaseKeyWindow,
  releaseProjectionKey,
  receiveErrors,
};
